module.exports = __webpack_public_path__ + "static/img/home_01.222c4f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/home_01.jpg
// module id = Xu7F
// module chunks = 1